  /**
   * @memberof rmOBA
   * @ngdoc directive
   * @name rmTabletNotice
   * @description
   *   Informatory notice for tablet users. ng-if used to display element based on user agent.
   * @example
   *   Usage:
   *        <rm-tablet-notice ng-if="isMobile()"></rm-tablet-notice>
   */
  
rmOBA.directive('rmTabletNotice', function() {
    return {
        restrict: 'E',
        templateUrl: 'directives/rmTabletNotice/rmTabletNotice.html',
        link: function (scope) {
        }
    }
});